import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';


const actualidad = {
	state: {
		noticias: '',
		promociones: '',
		notas : '',
		faqs : '',
		curiosidades : ''
	},
	getters: {
		categoriaNoticias: (state) => {

			let noticias = state.noticias;

			if (!!noticias) {

				let categorias = new Array();

				noticias.forEach(noticia => {


					if(typeof noticia.categoria == 'object'){

						noticia.categoria.forEach(cat => {
							
							if (categorias.length == 0) {
								categorias.push(cat)
							} else {
								if (!categorias.some(c => c.slug == cat.slug)) {
									categorias.push(cat)
								}
							}
						});
						
					}
				});

				return categorias;
			}
		},
		getNoticias: state => {
			return state.noticias;
		},
		getNotasPrensa: state => {
			return state.notas;
		},
		getpromociones: state => {
			return state.promociones;
		},
		getFaqs: state => {
			return state.faqs;
		},
		getCuriosidades: state => {
			return state.curiosidades;
		},
		getNoticiasFiltradas: state => {

			return (filtro) => {

				let searchIn = ['titulo', 'entradilla']

				let noticias = state.noticias;

				let filtradas;

				if (!!noticias) {

					filtradas = noticias.filter(noticia => {

						let can = false;

						searchIn.forEach(where => {
							(noticia[where].toLowerCase().includes(filtro.search.toLowerCase())) ? can = true : '';
						});

						return (can) ? noticia : '';
					});

					(!!filtro.categoria) ? filtradas = filtradas.filter(noticia => noticia.categoria.slug == filtro.categoria) : '';
				}

				return filtradas;

			}
		},
		getDestacadas: state => {
			let destacadas;
			if (!!state.noticias) {
				destacadas = state.noticias.filter(e => e.destacada == 1).slice(0, 2);
			}
			return destacadas;
		},
		getHasNoticias: state => {
			return (!!state.noticias);
		}
	},
	actions: {
		requestNoticias: ({ commit,getters } ) => {
			return new Promise((resolve, reject) => {

				axios.get(`/api/entries/${getters.getLanguage}/noticias`)
					.then(response => {
						commit('setNoticias', response.data.entries);
						resolve(true);
					})
					.catch(error => reject(error));

			});
		},
		requestNoticiasCategorias: ({ commit,getters }, cat) => {
			return new Promise((resolve, reject) => {

				axios.get(`/api/entries/${getters.getLanguage}/noticias/${cat}`)
					.then(response => {

						resolve(response.data.entries);
					})
					.catch(error => reject(error));

			});
		},
		requestNoticia: ({getters }, slug) => {

			return new Promise((resolve, reject) => {

				axios.get(`/api/entries/${getters.getLanguage}/noticia/${slug}`)
					.then(response => {
						resolve(response.data);
					})
					.catch(err => reject(error));

			});
		},
		requestBaseLegal: ({getters }, slug) => {

			return new Promise((resolve, reject) => {

				axios.get(`/api/entries/${getters.getLanguage}/base-legal/${slug}`)
					.then(response => {
						resolve(response.data);
					})
					.catch(err => reject(error));

			});
		},
		requestPromociones: ({ commit,getters }, ) => {
			return new Promise((resolve, reject) => {

				axios.get(`/api/entries/${getters.getLanguage}/promociones`)
					.then(response => {
						commit('setPromociones', response.data.entries);
						resolve(true);
					})
					.catch(error => reject(error));

			});
		},
		requestNotasPrensa: ({ commit,getters }, ) => {
			return new Promise((resolve, reject) => {

				axios.get(`/api/entries/${getters.getLanguage}/notas-presa`)
					.then(response => {
						commit('setNotasPrensa', response.data.entries);
						resolve(true);
					})
					.catch(error => reject(error));

			});
		},
		requestNotaPrensa: ({getters }, slug) => {

			return new Promise((resolve, reject) => {

				axios.get(`/api/entries/${getters.getLanguage}/nota-prensa/${slug}`)
					.then(response => {
						resolve(response.data);
					})
					.catch(err => reject(error));

			});
		},
		requestPromocion: ({ commit,getters }, slug) => {

			return new Promise((resolve, reject) => {

				axios.get(`api/entries/${getters.getLanguage}/promocion/${slug}`)
					.then(response => {
						resolve(response.data);
					})
					.catch(err => reject(error));

			});
		},
		requestFaqs: ({ commit,getters }) => {

			return new Promise((resolve, reject) => {

				axios.get(`api/${getters.getLanguage}/faq`)
					.then(response => {
						commit('setFaqs', response.data.data);
						resolve(true);
					})
					.catch(err => reject(error));

			});
		},
		requestCuriosidades: ({ commit,getters }) => {

			return new Promise((resolve, reject) => {

				axios.get(`api/${getters.getLanguage}/facts`)
					.then(response => {
						commit('setCuriosidades', response.data.data);
						resolve(true);
					})
					.catch(err => reject(error));

			});
		},
	},
	mutations: {
		setNoticias: (state, noticias) => {
			state.noticias = noticias;
		},
		setPromociones: (state, promociones) => {
			state.promociones = promociones;
		},
		setNotasPrensa: (state, notas) => {
			state.notas = notas;
		},
		setFaqs: (state, faqs) => {
			state.faqs = faqs;
		},
		setCuriosidades: (state, curiosidades) => {
			state.curiosidades = curiosidades;
		}
	}
}

export default actualidad;



// WEBPACK FOOTER //
// ./src/store/actualidad.js